class ScriptTypes {
		static{
				this._types = [];
		}
		static push(Type) {
				ScriptTypes._types.push(Type);
		}
}

export { ScriptTypes };
